import { HelpChapterCrashAutoplay } from '@pp/core/src/components/help/commonChapters/commonCrash/HelpChapterCrashAutoplay';
import { HelpChapterCrashCashingOutConnected } from '@pp/core/src/components/help/commonChapters/commonCrash/HelpChapterCrashCashingOutConnected';
import { HelpChapterCrashGameInconveniences } from '@pp/core/src/components/help/commonChapters/commonCrash/HelpChapterCrashGameInconveniences';
import type { HelpConfigType } from '@pp/core/src/components/help/types';

import { CrashHelpChapterHowToPlayConnected } from './chapters/CrashHelpChapterHowToPlayConnected';
import { CrashHelpChapterIntroduction } from './chapters/CrashHelpChapterIntroduction';
import { CrashHelpChapterLastResults } from './chapters/CrashHelpChapterLastResults';
import { CrashHelpChapterLeaderBoardAndStatistics } from './chapters/CrashHelpChapterLeaderBoardAndStatistics';
import { CrashHelpChapterMultiplier } from './chapters/CrashHelpChapterMultiplier';
import { CrashHelpChapterPlacingBets } from './chapters/CrashHelpChapterPlacingBets';
import { CrashHelpChapterReturnToPlayerConnected } from './chapters/CrashHelpChapterReturnToPlayerConnected';
import { HelpChapterCrashAutoCashingOutConnected } from './chapters/HelpChapterCrashAutoCashingOutConnected';
import { HelpChapterCrashDisconnectionPolicy } from './chapters/HelpChapterCrashDisconnectionPolicy';
import { HelpChapterCrashNavigationControls } from './chapters/HelpChapterCrashNavigationControls';
import { mapContextToStore } from './mapContextToStore';

export const helpConfig: HelpConfigType = {
  chapters: {
    introduction: CrashHelpChapterIntroduction,
    howToPlayHF: CrashHelpChapterHowToPlayConnected,
    multiplier: CrashHelpChapterMultiplier,
    placingBetsHF: CrashHelpChapterPlacingBets,
    cashingOutWithoutCashout50: HelpChapterCrashCashingOutConnected,
    autoCashoutWithoutCashout50: HelpChapterCrashAutoCashingOutConnected,
    autoplay: HelpChapterCrashAutoplay,
    lastResultHF: CrashHelpChapterLastResults,
    leaderboardAndStatistics: CrashHelpChapterLeaderBoardAndStatistics,
    returnToPlayer: CrashHelpChapterReturnToPlayerConnected,
    navigationControls: HelpChapterCrashNavigationControls,
    gameInconveniencesWithoutCashout50: HelpChapterCrashGameInconveniences,
    disconnectionPolicy: HelpChapterCrashDisconnectionPolicy,
  },
  mapContextToStore,
};
